var map = {
	"./icons8-chatgpt.svg": 6179,
	"./icons8-docker.svg": 4622,
	"./icons8-expo.svg": 8942,
	"./icons8-express-js.svg": 3638,
	"./icons8-firebase.svg": 9365,
	"./icons8-flask.svg": 8855,
	"./icons8-google-cloud.svg": 9291,
	"./icons8-heroku.svg": 450,
	"./icons8-javascript.svg": 5623,
	"./icons8-mongodb.svg": 5160,
	"./icons8-mysql-logo.svg": 9884,
	"./icons8-mysql.svg": 9428,
	"./icons8-node-js.svg": 6430,
	"./icons8-opencv.svg": 8553,
	"./icons8-python.svg": 7408,
	"./icons8-react-native.svg": 2037,
	"./icons8-react.svg": 8339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2636;